import Grid from "@mui/material/Grid";
import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import JobCard from "./JobCard";
import {getAllJobs, getJobsExternal} from "../../utilities/HrAPI";
import SearchBar from "../Jobs/SearchBar";
import {useLocation} from "react-router-dom";
import keycloak from "../../Keycloak";


export default function JobListing() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    // const clientId = Number(queryParams.get('clientId'))
    const clientId = queryParams.get('clientId')
    const [jobs, setJobs] = useState([])
    const [filteredJobs, setFilteredJobs] = useState([])
    const [dummyState, setDummyState] = useState(0);
    const [searchTerm, setSearchTerm] = useState("");
    const [cities, setCities] = useState([]);
    const [categories, setCategories] = useState([])
    const [types, setTypes] = useState([])
    const [filter, setFilter] = useState({type : "", region: "", category: ""})

    useEffect(() => {
        const processJobs = (jobList) => {
            setJobs(jobList);
            setFilteredJobs(jobList);

            const uniqueCities = [
                ...new Set(
                    jobList.map((job) => job.jobDetails.jobPlacement)
                        .flat()
                        .map((city) => city.trim())
                )
            ];

            const uniqueCategories = [
                ...new Set(
                    jobList.map((job) => job.jobDetails.jobCategory)
                )
            ];

            const uniqueTypes = [
                ...new Set(
                    jobList.map((job) => job.jobDetails.jobType)
                )
            ];

            setCities(uniqueCities);
            setCategories(uniqueCategories);
            setTypes(uniqueTypes);
        };

        if (clientId === 'all') {
            getAllJobs(keycloak.token)
                .then(processJobs)
                .catch((e) => {
                    console.error("Error fetching jobs:", e);
                });
        } else {
            getJobsExternal(clientId)
                .then(processJobs)
                .catch((e) => {
                    console.error("Error fetching jobs:", e);
                });
        }
    }, [clientId]);

    useEffect(() => {
        if (searchTerm.trim() === "") {
            setFilteredJobs(jobs); // Reset to the original jobs list
        } else {
            const filtered = jobs.filter(job =>
                job.jobTitle.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredJobs(filtered);
        }
        setDummyState(prev => prev + 1);
    }, [searchTerm, jobs]);

    useEffect(() => {
        let filtered = jobs;

        if (filter.type && filter.type !== 'all') {
            filtered = filtered.filter(job =>
                job.jobDetails.jobType?.includes(filter.type)
            );
        }

        if (filter.region && filter.region !== 'all') {
            filtered = filtered.filter(job =>
                job.jobDetails.jobPlacement?.includes(filter.region)
            );
        }

        if (filter.category && filter.category !== 'all') {
            filtered = filtered.filter(job =>
                job.jobDetails.jobCategory?.includes(filter.category)
            );
        }

        setFilteredJobs(filtered);
        setDummyState(prev => prev + 1); // If you need to update this state for other purposes
    }, [filter, jobs]);

    const handleSearch = (search) => {
        setSearchTerm(search); // Immediately update the search term
    };

    const filterTypes = (type) => {
        setFilter(prevFilters => ({ ...prevFilters, type }));
    };

    const filterCategories = (category) => {
        setFilter(prevFilters => ({ ...prevFilters, category }));
    };

    const filterRegions = (region) => {
        setFilter(prevFilters => ({ ...prevFilters, region }));
    };

    return (
        <Box data-testid={"details-page"} style={{height: 'max-content', backgroundColor: '#f3f3f3', elevation: 1}}>
            <Grid container spacing={2} padding={3} direction={"row"} justifyContent={"stretch"}>

                <Grid item xs={12}>
                    <SearchBar filterCategories={(category) => {filterCategories(category)}}
                               filterTypes={(type) => {filterTypes(type)}}
                               filterRegions={(region) => {filterRegions(region)}}
                               onSearch={(search) => {handleSearch(search)}}
                               regions={cities} categories={categories} types={types}/>
                </Grid>

                <Grid item xs={12}/>

                <Grid item xs={12}>
                    <Grid container direction={"row"} spacing={2} padding={2} key={dummyState}>
                        {filteredJobs && filteredJobs.length > 0 ? filteredJobs.map((job, index) => (
                            <Grid item xs={12} key={index}>
                                <JobCard data={job} clientId={clientId}/>
                            </Grid>
                        )) : (
                            <Grid item xs={12}>
                                <div className={"text-center"}>
                                    There are currently no roles available.
                                </div>
                            </Grid>
                        )}
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    )
}